import React from 'react';
import './HoldPage.css'; // Importing the CSS file for styling

// Component to display when the website is on hold due to pending payment
const HoldPage = () => {
  return (
    <div className="hold-page-container">
      <div className="hold-page-content">
        <h1 className="hold-page-title">Website Temporarily On Hold</h1>
        <p className="hold-page-message">
          We apologize for the inconvenience. The website is currently on hold due to a pending payment.
        </p>
        <p className="hold-page-contact">
          Please contact our support team at{' '}
          <a href="mailto:sriharimuppalla64@gmail.com" className="hold-page-link">
            sriharimuppalla64@gmail.com
          </a>{' '}
          or call us at{' '}
          <a href="tel:+919346359910" className="hold-page-link">
            +91 9346359910
          </a>{' '}
          for assistance.
        </p>
      </div>
    </div>
  );
};

export default HoldPage;